module.exports = __webpack_public_path__ + "img/20-scut-polito-logo.1d04a163.png";